import React, { useState, useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { obtenerPersonaExtranjeraApi, guardarDatosPersonaExtranjeraApi } from "../api/contratacion/datosPersonaExtranjeraApi";
import { obtenerDatosPersonalesApi, guardarDatosPersonalesApi } from "../api/contratacion/datosPersonalesApi";
import { obtenerDatosBancariosApi, guardarDatosBancariosApi } from "../api/contratacion/datosBancariosApi";
import { obtenerDatosPrevisioApi, guardarDatosPrevisionApi } from "../api/contratacion/datosPrevisionApi";
import { obtenerVacanteApi, aprobarSolicitudVacanteApi } from "../api/contratacion/solicitudVacanteApi";
import { obtenerDireccionApi, guardarDireccionApi } from "../api/contratacion/datosDireccionApi";
import { obtenerDatosSaludApi, guardarDatosSaludApi } from "../api/contratacion/datosSaludApi";
import { obtenerDocumentoApi, guardarDocumentoApi } from "../api/contratacion/documentosApi";
import { SubirDataTemporalApi, SubirDataTemporisApi } from "../api/listas/temporisApi.js";
import { guardarDatosLaboralesApi } from "../api/contratacion/datosLaboralesApi";
import FormDatosPersonales from "./procesoContratacion/FormDatosPersonales";
import FormDatosBancarios from "./procesoContratacion/FormDatosBancarios";
import FormDatosDireccion from "./procesoContratacion/FormDatosDireccion";
import FormDatosPrevision from "./procesoContratacion/FormDatosPrevision";
import { modalCargando, modalComentario } from "./ui/sweetAlerts";
import FormDocumentos from "./procesoContratacion/FormDocumentos";
import { DOCUMENTOS } from "../utils/Constants";
import { SpinnerModal } from "./ui/Spinner";
import { HtmlList } from "./ui/HtmlList";
import { Modal } from "react-bootstrap";
import { useFormik } from "formik";
import { post } from "../api/apis";
import Swal from "sweetalert2";

import { useDatosPersonalesExtranjero } from "./procesoContratacion/useDatosPersonalesExtranjero.js";
import { useDatosPersonales } from "./procesoContratacion/useDatosPersonales.js";
import { useDatosDireccion } from "./procesoContratacion/useDatosDireccion.js";
import { useDatosLaborales } from "./procesoContratacion/useDatosLaborales.js";
import { useDatosBancarios } from "./procesoContratacion/useDatosBancarios.js";
import { useDatosPrevision } from "./procesoContratacion/useDatosPrevision.js";
import { useDocumentos } from "./procesoContratacion/useDocumentos.js";

export const EditarContratacionScreen = () => {
  const { state } = useLocation();
  const [visibleSpinner, setVisibleSpinner] = useState(true);
  const [datosExtranjero, setDatosExtranjero] = useState([]);
  const [datosLaborales, setDatosLaborales] = useState([]);
  const [datosDireccion, setDatosDireccion] = useState([]);
  const [datosBancarios, setDatosBancarios] = useState([]);
  const [datosPrevision, setDatosPrevision] = useState([]);
  const [datosDocumento, setdatosDocumento] = useState([]);
  const [visibleModal, setVisibleModal] = useState(false);
  const [listaGuardado, setListaGuardado] = useState([]);
  const [datosPersona, setDatosPersona] = useState({});
  const [guardadoTemporal, setGuardadoTemporal] = useState(false);
  const [datosSalud, setDatosSalud] = useState([]);
  const [txtSpinner, setTxtSpinner] = useState("");
  const navigate = useNavigate();
  const params = useParams();
  const msjCorrecto = ", guardado correctamente.";
  const msjIncorrecto = ", no se pudo guardar.";

  const { validatePersonalesExtranjero } = useDatosPersonalesExtranjero();
  const { validateDocumentos, objDocumentos } = useDocumentos();
  const { validatePersonales } = useDatosPersonales();
  const { validateDireccion } = useDatosDireccion();
  const { validateLaborales } = useDatosLaborales();
  const { validatePrevision } = useDatosPrevision();
  const { validateBancarios } = useDatosBancarios();
  const { idSolicitud } = params;

  function setearMensaje(tipo, resp) {
    setListaGuardado(listaGuardado => [
      ...listaGuardado,
      {
        icono: `${resp.status === "success" ? "check.png" : "warning.png"}`,
        texto: `${tipo}${resp.status === "success" ? msjCorrecto : msjIncorrecto}`,
      },
    ]);
  }

  const redireccionar = stat => {
    if (stat === "success") {
      setTimeout(() => {
        window.location = "/";
      }, 300000);
    }
  };

  const guardarSolicitud = async (idPersona, idSolicitud) => {
    if (guardadoTemporal) {
      setTxtSpinner(() => setTxtSpinner("Solicitud"));
      const resp = await post("solicitud", null, {
        id_persona: idPersona,
        guardado_temporal: 0,
        trabajador_nuevo: datosPersona.reingreso === 1 ? 0 : 1, // se refiere a si el proceso ya se encuentra en proceso o se esta ingresando los datos de un trabjador nuevo sin necesidad de ser aprobado por rrhh
      });
      setearMensaje("Solicitud", resp.data);

      await SubirDataTemporisApi(idPersona);
      await SubirDataTemporalApi(idPersona, idSolicitud);
    }
  };

  useEffect(() => {
    setGuardadoTemporal(state.solicitud.guardado_temporal !== 0);
  }, [state]);

  const saveNewDataFrom = async (values, personaSolicitante = false, editaVacante = true, observaciones = "") => {
    setVisibleModal(!visibleModal);

    setTxtSpinner(() => setTxtSpinner("Datos personales"));
    let resp = await guardarDatosPersonalesApi(values.datosPersonales);
    setearMensaje("Datos personales", resp);

    const idPersona = resp.data.id_persona;

    if (!["", "1", 1].includes(values.datosPersonales.nacionalidad)) {
      setTxtSpinner(() => setTxtSpinner("Datos extranjería"));
      const respExtranjero = await guardarDatosPersonaExtranjeraApi(values.datosPersonaExtranjera, idPersona);
      setearMensaje("Datos extranjería", respExtranjero);
    }

    setTxtSpinner(() => setTxtSpinner("Datos bancarios"));
    resp = await guardarDatosBancariosApi(values.datosBancarios, idPersona);
    setearMensaje("Datos bancarios", resp);

    setTxtSpinner(() => setTxtSpinner("Datos previsión"));
    resp = await guardarDatosPrevisionApi(values.datosPrevision, idPersona);
    setearMensaje("Datos previsión", resp);

    setTxtSpinner(() => setTxtSpinner("Datos salud"));
    resp = await guardarDatosSaludApi(values.datosPrevision, idPersona);
    setearMensaje("Datos salud", resp);

    setTxtSpinner(() => setTxtSpinner("Datos dirección"));
    resp = await guardarDireccionApi(values.datosDireccion, idPersona);
    setearMensaje("Datos dirección", resp);

    await Promise.all(
      DOCUMENTOS.map(async dataDocumento => {
        if (typeof values.datosDocumentos[dataDocumento.documento] === "object") {
          setTxtSpinner(() => setTxtSpinner("Documento"));
          const respDocumento = await guardarDocumentoApi(values.datosDocumentos[dataDocumento.documento], idPersona, dataDocumento["id_tipo"]);
          setearMensaje("Documento", respDocumento);
        }
      }),
    );

    // Si es guardado temporal, significa que está haciendo el envío definitivo de la solicitud. De lo contrario será solo edición del formulario
    await guardarSolicitud(idPersona, idSolicitud);

    if (personaSolicitante && editaVacante) {
      let ingresarDatosLAborales = false;

      if (ingresarDatosLAborales || personaSolicitante.idSolicitud) {
        setTxtSpinner(() => setTxtSpinner("Datos laborales"));
        const respDatosLaborales = await guardarDatosLaboralesApi(values.datosLaborales, idSolicitud);
        setearMensaje("Datos laborales", respDatosLaborales);

        if (personaSolicitante.idSolicitud) {
          setTxtSpinner(() => setTxtSpinner("Vacante"));
          const respSolicitante = await aprobarSolicitudVacanteApi(idSolicitud);
          setearMensaje("Vacante", respSolicitante);
        }

        redireccionar(respDatosLaborales.status);
      }
    }

    if (localStorage.getItem("id_perfil") === "4" && guardadoTemporal === false) {
      setTxtSpinner(() => setTxtSpinner("Enviando reconsideración"));
      const respConsideracion = await post("envioreconsideracion", { idSolicitud: state.idSolicitud }, { observaciones: observaciones });

      if (respConsideracion.data.status === "success") {
        setearMensaje("Reconsideración", respConsideracion.data);
      }
    }

    setVisibleSpinner(!visibleSpinner);
  };

  const obtenerInfo = async () => {
    modalCargando("Obteniendo datos...");
    await obtenerDatosPersonalesApi(state.idPersonaSolicitud)
      .then(res => {
        if (res.status === "success") setDatosPersona(res.data);
      })
      .catch(error => console.log("Error :", error));
    await obtenerVacanteApi(state.idPersonaSolicitud, state.idSolicitud)
      .then(res => {
        if (res.status === "success") setDatosLaborales(res.data);
      })
      .catch(error => console.log("Error :", error));
    await obtenerPersonaExtranjeraApi(state.idPersonaSolicitud, state.idSolicitud)
      .then(res => {
        if (res.status === "success") setDatosExtranjero(res.data);
      })
      .catch(error => console.log("Error :", error));

    await obtenerDatosPrevisioApi(state.idPersonaSolicitud, state.idSolicitud)
      .then(res => {
        if (res.status === "success") setDatosPrevision(res.data);
      })
      .catch(error => console.log("Error :", error));

    await obtenerDatosSaludApi(state.idPersonaSolicitud, state.idSolicitud)
      .then(res => {
        if (res.status === "success") setDatosSalud(res.data);
      })
      .catch(error => console.log("Error :", error));

    await obtenerDireccionApi(state.idPersonaSolicitud)
      .then(res => {
        if (res.status === "success") setDatosDireccion(res.data);
      })
      .catch(error => console.log("Error :", error));

    await obtenerDatosBancariosApi(state.idPersonaSolicitud)
      .then(res => {
        if (res.status === "success") setDatosBancarios(res.data);
      })
      .catch(error => console.log("Error :", error));

    await obtenerDocumentoApi(state.idPersonaSolicitud)
      .then(res => {
        if (res.status === "success") setdatosDocumento(res.data);
      })
      .catch(error => console.log("Error :", error));
    Swal.close();
  };

  const validate = values => {
    const { nacionalidad } = values.datosPersonales;
    const { tipoVisa } = values.datosPersonaExtranjera;
    const { jubilado } = values.datosPrevision;
    const { certificadoCovid } = values.datosPrevision;
    let errors = {
      datosLaborales: validateLaborales(values.datosLaborales, state.solicitud.id_estado_solicitud),
      datosPersonales: validatePersonales(values.datosPersonales),
      datosPersonaExtranjera: validatePersonalesExtranjero({ ...values.datosPersonaExtranjera, nacionalidad }),
      datosDireccion: validateDireccion(values.datosDireccion),
      datosPrevision: validatePrevision(values.datosPrevision),
      datosBancarios: validateBancarios(values.datosBancarios),
      datosDocumentos: validateDocumentos({ ...values.datosDocumentos, certificadoCovid, tipoVisa, jubilado, nacionalidad }),
    };

    return Object.values(errors).every(el => Object.values(el).length === 0) ? {} : errors;
  };

  const acccionVerVacante = async (idSolicitud, idPersonaSolicitud, solicitud) => {
    return navigate(`/vacante/${idSolicitud}`, { state: { idSolicitud, idPersonaSolicitud, solicitud } });
  };

  const formik = useFormik({
    enableReinitialize: true,
    validate,
    initialValues: {
      datosLaborales: {
        fechaIngreso: datosLaborales.fecha_ingreso || "",
        cargo: datosLaborales.nombre_vacante || "",
        planHorario: datosLaborales.temporis_plan_horario || "",
        unidadOrganizativaRolTemporis: "",
        cargoRolTemporis: "",
        tipoContrato: datosLaborales.tipo_contrato || "",
        fechaFinContrato: datosLaborales.fecha_retiro || "",
      },
      datosPersonales: {
        rut: datosPersona.identificacion || "",
        id_persona: datosPersona.id || "",
        nombres: datosPersona.nombre || "",
        apellidoPaterno: datosPersona.apellido_pat || "",
        apellidoMaterno: datosPersona.apellido_mat || "",
        fechaNacimiento: datosPersona.fecha_nacimiento || "",
        sexo: datosPersona.id_persona_genero || "",
        estadoCivil: datosPersona.id_persona_estado_civil || "",
        nivelFormacion: datosPersona.id_educacion_nivel || "",
        nacionalidad: datosPersona.id_pais || "",
        email: datosPersona.correo || "",
        telefonoCelular: datosPersona.telefono || "",
      },
      datosPersonaExtranjera: {
        tipoVisa: datosExtranjero.id_persona_tipo_visa || "",
        visaTemporariaDesde: datosExtranjero.fecha_visa_temporaria || "",
        visaTemporariaHasta: datosExtranjero.fecha_vencimiento_visa || "",
      },
      datosDireccion: {
        calle: datosDireccion.direccion || "",
        numeroCasa: datosDireccion.numero || "",
        numeroDepartamento: datosDireccion.numero_departamento || "",
        region: datosDireccion.id_region || "",
        comuna: datosDireccion.id_comuna || "",
        pais: datosDireccion.id_pais || "",
        tipoDireccion: datosDireccion.id_tipo_direccion || "",
      },
      datosPrevision: {
        jubilado: datosPrevision.jubilado?.toString(),
        previsionSalud: datosSalud.id_institucion_salud || "",
        previsionSocial: datosPrevision.id_afp || "",
        planPactado: datosSalud.valor_plan || 0,
        certificadoCovid: datosSalud.certificaco_covid || 0,
        certificadoDiscapacidad: datosSalud.certificaco_discapacidad || 0,
      },
      datosBancarios: {
        formaDePago: datosBancarios.tipo_pago,
        banco: datosBancarios.id_banco,
        tipoCuenta: datosBancarios.id_tipo_cuenta,
        numeroCuenta: datosBancarios.numero_cuenta,
      },
      datosDocumentos: objDocumentos(datosDocumento),
    },
    onSubmit: (values, comentario) => {
      saveNewDataFrom(values, false, false);
    },
  });

  useEffect(() => {
    formik.setErrors(validate(formik.values));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formik.values]);

  useEffect(() => {
    if (Object.keys(formik.values.datosDocumentos).length === 0) return;

    if (["1"].includes(formik.values.datosPersonales.nacionalidad)) {
      formik.setValues({
        ...formik.values,
        datosDocumentos: {
          ...formik.values.datosDocumentos,
          visa: undefined,
        },
      });
    }
  }, [formik.values.datosPersonales.nacionalidad]);

  useEffect(() => {
    obtenerInfo();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Modal show={visibleModal}>
        <HtmlList lista={listaGuardado} />

        {visibleSpinner && <SpinnerModal txt={txtSpinner} />}

        {!visibleSpinner && (
          <div className="text-center">
            <button
              className="btnArcoprime mb-4 mt-2"
              onClick={() => {
                setVisibleSpinner(!visibleSpinner);
                setVisibleModal(!visibleModal);
                acccionVerVacante(state.idSolicitud, state.idPersonaSolicitud, state);
              }}
            >
              Entendido
            </button>
          </div>
        )}
      </Modal>

      <div className="mx-5 px-5">
        <div className="card my-4">
          <div className="card-header bgArcopime">
            <h3 className="my-0">Datos personales</h3>
          </div>
          <div className="card-body">
            <FormDatosPersonales formik={formik} />
          </div>
        </div>
        <div className="card my-4">
          <div className="card-header bgArcopime">
            <h3 className="my-0">Dirección</h3>
          </div>
          <div className="card-body">
            <FormDatosDireccion formik={formik} />
          </div>
        </div>
        <div className="card my-4">
          <div className="card-header bgArcopime">
            <h3 className="my-0">Datos previsión</h3>
          </div>
          <div className="card-body">
            <FormDatosPrevision formik={formik} />
          </div>
        </div>
        <div className="card my-4">
          <div className="card-header bgArcopime">
            <h3 className="my-0">Datos bancarios</h3>
          </div>
          <div className="card-body">
            <FormDatosBancarios formik={formik} />
          </div>
        </div>
        <div className="card my-2">
          <div className="card-body">
            <h3>Subir documentos nuevos</h3>
            <FormDocumentos formik={formik} />
          </div>
        </div>
        <div className="card my-2">
          <div className="card-body">
            <h3>Documentos cargados</h3>
            <div className="row">
              {datosDocumento.map(documento => (
                <div className="col-lg-3 col-sm-3" key={documento.url.replaceAll(" ", "")}>
                  <div className="card border-dark mb-3">
                    <div className="card-header">{documento.documento}</div>
                    <div className="card-body text-dark">
                      <a target="_blank" rel="noreferrer" href={documento.url} className="btn btn-outline-success">
                        ver documento
                      </a>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className="d-grid gap-2 d-md-flex justify-content-md-end mb-3">
          <button
            className="btn btn-outline-primary me-md-2"
            type="button"
            onClick={() => {
              navigate(-1);
            }}
          >
            Volver
          </button>
          <button
            disabled={JSON.stringify(formik.errors) !== "{}"}
            className="btn btn-primary"
            type="button"
            onClick={() => {
              const txtTitulo = localStorage.getItem("id_perfil") === "4" ? "Enviar Reconsideración" : "Guardar";
              if (localStorage.getItem("id_perfil") === "4" && guardadoTemporal === false) {
                modalComentario(saveNewDataFrom, txtTitulo, formik.values);
              }
              if (localStorage.getItem("id_perfil") === "3" || (localStorage.getItem("id_perfil") === "4" && guardadoTemporal === true)) {
                saveNewDataFrom(formik.values);
              }
            }}
          >
            {localStorage.getItem("id_perfil") === "4" && guardadoTemporal === false && "Enviar Reconsideración"}

            {(localStorage.getItem("id_perfil") === "3" || (localStorage.getItem("id_perfil") === "4" && guardadoTemporal === true)) && "Guardar"}
          </button>
        </div>
      </div>
    </>
  );
};
